exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-product-gallery[data-v-75f2deb4]{-ms-flex:1 1;flex:1 1}\n", ""]);

// exports
